export const SNOWPACK_PUBLIC_API_USERS_URL = import.meta.env.VITE_PUBLIC_API_USERS_URL ?? ''
